(function () {
  let scheduled = false;

  function getShippingAnchor() {
    // 1) Try a heading that contains "Shipping".
    const heading = Array.from(document.querySelectorAll('h2, h3'))
      .find((candidate) => /shipping/i.test(candidate.textContent.trim()));
    if (heading) return heading.closest('section') || heading.parentElement;

    // 2) Fallback: wrapper observed in checkout/account markup.
    return document.querySelector('.jHvVd');
  }

  function moveDiscount() {
    scheduled = false;

    const discount = document.getElementById('gift-card-field');
    const ship = getShippingAnchor();
    if (!discount || !ship) return;

    // Already placed.
    if (ship.nextElementSibling === discount) return;

    ship.insertAdjacentElement('afterend', discount);
  }

  function scheduleMoveDiscount() {
    if (scheduled) return;
    scheduled = true;

    const frame = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); };
    frame(moveDiscount);
  }

  function init() {
    scheduleMoveDiscount();

    if (!document.body || document.body.dataset.discountPlacementObserver === 'true') return;
    document.body.dataset.discountPlacementObserver = 'true';

    new MutationObserver(scheduleMoveDiscount)
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
